import { Injectable, inject } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BackButtonService {
  private location = inject(PlatformLocation);
  private translate = inject(TranslateService);
  private router = inject(Router);
  private snackBar = inject(MatSnackBar);
  
  private lastBackPress = 0;
  private readonly EXIT_TIME_THRESHOLD = 2000;
  private readonly targetRoutes = ['/home', '/home/(home:greetings)'];

  initHomeBackHandler() {
    // 1. ESCUDO DE NAVEGAÇÃO: Monitora quando o usuário chega na Home
    // vindo de qualquer outra parte do app (como o Invite ou Login)
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      if (this.isProtectedRoute()) {
        this.applyTrapState();
      }
    });

    // 2. INTERCEPTADOR DE BOTÃO VOLTAR
    this.location.onPopState(() => {
      if (this.isProtectedRoute()) {
        /** * A MÁGICA: Re-injetamos o estado ANTES de qualquer lógica.
         * Isso garante que, se o usuário clicar em voltar 10 vezes devagar,
         * ele continuará preso na Home em todas as 10 vezes.
         */
        this.applyTrapState();

        const currentTime = Date.now();

        if ((currentTime - this.lastBackPress) < this.EXIT_TIME_THRESHOLD) {
          this.exitApp();
        } else {
          this.lastBackPress = currentTime;
          this.showExitWarning();
        }
      }
    });

    // Verificação inicial caso o app já carregue em uma rota protegida
    if (this.isProtectedRoute()) {
      this.applyTrapState();
    }
  }

  private isProtectedRoute(): boolean {
    // Remove query params para garantir que '/home?xxx' ainda seja protegida
    const currentUrl = this.router.url.split('?')[0];
    return this.targetRoutes.includes(currentUrl);
  }

  private applyTrapState() {
    // Adiciona uma entrada extra no histórico que aponta para a mesma URL
    history.pushState(null, '', window.location.href);
  }

  private showExitWarning() {
    this.snackBar.open(
      this.translate.instant('info.close_app'),
      this.translate.instant('buttons.dismiss'), 
      {
        duration: 2000,
        verticalPosition: 'bottom'
      }
    );
  }

  private exitApp() {
    // Fecha a PWA se estiver instalada ou se o navegador permitir
    window.close();
    
    // Fallback: se não puder fechar, ao menos o usuário 
    // está preso na Home pelo applyTrapState acima.
  }
}